import { ArrowDownward } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, FormControlLabel, FormGroup, Grid, Switch, TextField } from '@mui/material';
import { useState } from 'react';
import { Brush, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatDate, helpers } from '../../../services/helpers/helpers';

interface ILineChart {
    data: any[],
    // name: string,
    // lineKey: string[],
    // yAxis: string,
    // yText: string,
    // xAxis: string,
}


export const Landmarks = ({data}: ILineChart) => {
    

    console.log(data);
    


    const [dotSize, setDotSize] = useState(5);
    const [lineSize, setLineSize] = useState(5);
    const [showDot, setShowDot] = useState(true);
    // const [layout, setLayout] = useState<'horizontal' | 'vertical'>('horizontal');
    // const [align, setAlign] = useState<'center' | 'left' | 'right'>('center');
    // const [verticalAlign, setVerticalAlign] = useState<'bottom' | 'middle' | 'top'>('bottom');

    // const theme = useTheme();

    const handleChangeShowDot = () => {
        setShowDot(!showDot);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleDotSizeChange = (event: any) => {
        setDotSize(event.target.value);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleLineSizeChange = (event: any) => {
        setLineSize(event.target.value);
    };

    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const handleLayoutChange = (event: any) => {
    //     setLayout(event.target.value);
    // };

    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const handleAlignChange = (event: any) => {
    //     setAlign(event.target.value);
    // };

    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const handleVerticalAlignChange = (event: any) => {
    //     setVerticalAlign(event.target.value);
    // };

		console.log(data);
		

    return(
        <Container>
            <Box width={'100%'} justifyContent={'center'} alignContent={'center'} padding={2} gap={1}>
                <Box width={'100%'}>
                    <ResponsiveContainer width={'100%'} height={350} >
                        <LineChart
                            data={data}
                            margin={{ top: 5, right: 50, left: 50, bottom: 5 }}
                            syncId="anyId"
                        >
                            <CartesianGrid strokeDasharray='3 3' />
                            <YAxis label={{ value: 'Deslocamento X', angle: -90, position: 'insideLeft', dy: 60, dx: -40}} />
                            <XAxis dataKey='data_leitura' tickFormatter={helpers.formatXAxisDate}/>
                            <Tooltip />
                            <Legend />
                            
                            <Line key='desl_abs_x' type='monotone' dataKey='desl_abs_x' name='Deslocamento Absoluto X' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
                            <Line key='desl_rel_x' type='monotone' dataKey='desl_rel_x' name='Deslocamento Relativo X' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
                        </LineChart>
                    </ResponsiveContainer>
                    <ResponsiveContainer width={'100%'} height={300}>
                        <LineChart
                            data={data}
                            margin={{ top: 5, right: 50, left: 50, bottom: 5 }}
                            syncId="anyId"
                        >
                            <CartesianGrid strokeDasharray='3 3' />
                            <YAxis label={{ value: 'Deslocamento Y', angle: -90, position: 'insideLeft', dy: 60, dx: -40 }} tickFormatter={(value) => value.toFixed(2)}/>
                            <XAxis dataKey='data_leitura'tickFormatter={helpers.formatXAxisDate} />
                            <Tooltip />
                            <Legend />
                            <Line type='monotone' dataKey='desl_abs_y' name='Deslocamento Absoluto Y' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
                            <Line type='monotone' dataKey='desl_rel_y' name='Deslocamento Relativo Y' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
                        </LineChart>
                    </ResponsiveContainer>
                    <ResponsiveContainer width={'100%'} height={300}>
                        <LineChart
                            data={data}
                            margin={{ top: 5, right: 50, left: 50, bottom: 5 }}
                            syncId="anyId"
                        >
                            <CartesianGrid strokeDasharray='3 3' />
                            <YAxis label={{ value: 'Deslocamento Z', angle: -90, position: 'insideLeft', dy: 60, dx: -40 }}/>
                            <XAxis dataKey='data_leitura' tickFormatter={helpers.formatXAxisDate}/>
                            <Tooltip />
                            <Legend />
                            <Line type='monotone' dataKey='desl_abs_z' name='Deslocamento Absoluto Z' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
                            <Line type='monotone' dataKey='desl_rel_z' name='Deslocamento Relativo Z' stroke={`#${Math.floor(Math.random()*16777215).toString(16)}`} strokeWidth={lineSize} dot={showDot ? { strokeWidth: dotSize } : false}/>
														<Brush dataKey={'data_leitura'} height={25}/>
                        </LineChart>
                    </ResponsiveContainer>
                </Box>
                <Box width={'100%'}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ArrowDownward/>}>
                            Personalização do Gráfico
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box marginTop={5}>
                                <Grid container spacing={2}  padding={2}>
                                    <Grid item container alignItems={'center'} spacing={2} justifyContent={'center'}>
                                        <Grid item xs={4}>
                                            <TextField 
                                                label='Tamanho do Marcador' 
                                                value={dotSize} 
                                                type='number' 
                                                variant='filled' 
                                                onChange={handleDotSizeChange}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField 
                                                label='Tamanho da linha' 
                                                value={lineSize} 
                                                type='number' 
                                                variant='filled' 
                                                onChange={handleLineSizeChange}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormGroup>
                                                <FormControlLabel control={<Switch checked={showDot} onChange={handleChangeShowDot} />} label="Mostrar Marcador" />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid item container spacing={2}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>Tipo de legenda</InputLabel>
                                                <Select value={layout} onChange={handleLayoutChange}>
                                                    <MenuItem value={'vertical'}>Vertical</MenuItem>
                                                    <MenuItem value={'horizontal'}>Horizontal</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>Alinhamento X de legenda</InputLabel>
                                                <Select value={align} onChange={handleAlignChange}>
                                                    <MenuItem value={'center'}>Central</MenuItem>
                                                    <MenuItem value={'left'}>Esquerda</MenuItem>
                                                    <MenuItem value={'right'}>Direita</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>Alinhamento Y de legenda</InputLabel>
                                                <Select value={verticalAlign} onChange={handleVerticalAlignChange}>
                                                    <MenuItem value={'bottom'}>Baixo</MenuItem>
                                                    <MenuItem value={'top'}>Cima</MenuItem>
                                                    <MenuItem value={'middle'}>Meio</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid> */}
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
        </Container>
    );
};